import axios from 'axios';

export default class MavenKeys {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async getAPIKeys(accountId) {
    const result = await axios({
      url: `${this.baseURL}/api-keys/${accountId}`,
      method: 'GET',
    });
    return result.data;
  }

  async createAPIKey(accountId) {
    const result = await axios({
      url: `${this.baseURL}/api-keys/${accountId}`,
      method: 'POST',
      data: [],
    });
    return result.data;
  }

  async deleteAPIKey(accountId, apiKey) {
    const result = await axios({
      url: `${this.baseURL}/api-keys/${accountId}/${apiKey}`,
      method: 'DELETE',
    });
    return result.data;
  }

  async regenerateAPIKey(accountId, apiKey) {
    await this.deleteAPIKey(accountId, apiKey);
    return this.createAPIKey(accountId);
  }
}
